var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgPlay(props) {
    return (React.createElement("svg", __assign({ fill: '#fff', viewBox: '-40 0 36 36' }, props),
        React.createElement("path", { fillRule: 'evenodd', d: 'M-7.558 20.605l-25.954 14.83A3 3 0 01-38 32.83V3.17A3 3 0 01-33.512.565l25.954 14.83a3 3 0 010 5.21z' })));
}
export default SvgPlay;
//# sourceMappingURL=Play.js.map